export const DMP_CHAT_LAST_ACTIVE_STORAGE_PREFIX = 'dmp-chat-last-active:'

export function getDmpChatLastActiveStorageKey(projectId: number): string {
  return `${DMP_CHAT_LAST_ACTIVE_STORAGE_PREFIX}${projectId}`
}

export function readDmpChatLastActive(projectId: number): string | null {
  const storage = getSessionStorage()
  if (!storage) {
    return null
  }

  try {
    const value = storage.getItem(getDmpChatLastActiveStorageKey(projectId))?.trim()
    return value || null
  } catch {
    return null
  }
}

export function writeDmpChatLastActive(projectId: number, chatHistoryId: string): void {
  const storage = getSessionStorage()
  const normalizedChatHistoryId = chatHistoryId.trim()
  if (!storage || !normalizedChatHistoryId) {
    return
  }

  try {
    storage.setItem(getDmpChatLastActiveStorageKey(projectId), normalizedChatHistoryId)
  } catch {
    // A restricted browser storage implementation should not block chat rendering.
  }
}

export function clearDmpChatLastActive(projectId: number): void {
  const storage = getSessionStorage()
  if (!storage) {
    return
  }

  try {
    storage.removeItem(getDmpChatLastActiveStorageKey(projectId))
  } catch {
    // A restricted browser storage implementation should not block chat rendering.
  }
}

export function selectDmpChatLastActive(
  storedChatHistoryId: string | null,
  availableChatHistoryIds: readonly string[]
): string | null {
  if (!storedChatHistoryId) {
    return null
  }

  return availableChatHistoryIds.includes(storedChatHistoryId) ? storedChatHistoryId : null
}

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.sessionStorage
  } catch {
    return null
  }
}
